import { useEffect, useRef, useState } from 'react';
import ChartsEmbedSDK from '@mongodb-js/charts-embed-dom';
import { Box } from '@mui/material';
import { shallow } from 'zustand/shallow';
import useAuthStore from 'store/useAuthStore';
import { styled } from '@mui/material/styles';

const MONGO_CHARTS_BASE_URL = process.env?.REACT_APP_MONGO_CHARTS_BASE_URL || '';

type ChartProps = {
  chartId: string;
  filter?: Record<string, string | undefined>;
};

const Chart = ({ chartId, filter }: ChartProps) => {
  const accessToken = useAuthStore((state) => state.accessToken, shallow);
  const sdk = new ChartsEmbedSDK({
    baseUrl: MONGO_CHARTS_BASE_URL,
    getUserToken: () => accessToken,
    showAttribution: false,
  });
  const chartDiv = useRef<HTMLDivElement | null>(null);
  const [rendered, setRendered] = useState(false);
  const [chart] = useState(
    sdk.createChart({
      chartId,
      filter,
    }),
  );

  useEffect(() => {
    chart
      .render(chartDiv.current as HTMLElement)
      .then(() => setRendered(true))
      .catch((err) => console.log('Error during Charts rendering.', err));
  }, [chart]);

  useEffect(() => {
    if (rendered) {
      // chart
      //   .setFilter({  })
      //   .catch((err) => console.log('Error while filtering.', err));
    }
  }, [chart, rendered]);

  return <ChartContainer ref={chartDiv} />;
};

const ChartContainer = styled(Box, { label: 'ChartContainer' })({
  minWidth: '400px',
  minHeight: '400px',
  width: '100%',
  height: '100%',
});

export default Chart;
